module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjEuMzUgMTEuMWgtOS4xN3YyLjczaDYuNTFjLS4zMyAzLjgxLTMuNSA1LjQ0LTYuNSA1LjQ0QzguMzYgMTkuMjcgNSAxNi4yNSA1IDEyYzAtNC4xIDMuMi03LjI3IDcuMi03LjI3IDMuMDkgMCA0LjkgMS45NyA0LjkgMS45N0wxOSA0LjcyUzE2LjU2IDIgMTIuMSAyQzYuNDIgMiAyLjAzIDYuOCAyLjAzIDEyYzAgNS4wNSA0LjEzIDEwIDEwLjIyIDEwIDUuMzUgMCA5LjI1LTMuNjcgOS4yNS05LjA5IDAtMS4xNS0uMTUtMS44MS0uMTUtMS44MXoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/google.svg
// module id = 542
// module chunks = 0